import React from 'react';
import {NavLink, Navigate, Outlet, useNavigate} from 'react-router-dom';
import { Account } from './services/Account';
import { BsArchiveFill, BsDiscord, BsBroadcast, BsBookFill, BsCarFrontFill, BsEnvelope, BsFacebook, BsFillHouseFill, BsFillPlayCircleFill, BsFillTrophyFill, BsFilterCircleFill, BsGoogle, BsPersonCircle, BsTools, BsTwitch, BsTwitter, BsShieldLock, BsTiktok, BsClockHistory, BsGrid3X3GapFill, BsCheckCircleFill, BsPlayBtnFill, BsConeStriped, BsCollectionPlayFill } from 'react-icons/bs';
import './MainPage.css';
import { Network } from './services/Network';
import { Auth0Provider, useAuth0 } from '@auth0/auth0-react';
import { useEffect, useState } from 'react';
import { PlayFab } from './services/PlayFab';
import { useLocation } from 'react-router-dom';

const menu = [
  {label: 'Home', link: '/', icon: <BsFillHouseFill style={{transform: 'translateY(2px)'}} />},
  {label: 'Submit Hands', link: '/buddy', icon: <BsFillPlayCircleFill style={{transform: 'translateY(2px)'}} />},
  {label: 'Hand Notes', link: '/handnotes', icon: <BsShieldLock style={{transform: 'translateY(2px)'}} />},
  {label: 'Visualiser', link: '/visualiser', icon: <BsPlayBtnFill style={{transform: 'translateY(2px)'}} />},
  {label: 'Hand Review', link: '/hand-review', icon: <BsCollectionPlayFill style={{transform: 'translateY(2px)'}} />},
  {label: 'Profile', link: '/profile', icon: <BsPersonCircle style={{transform: 'translateY(2px)'}} />, requireLogin: true},
  {label: 'Charts', link: '/charts', icon: <BsGrid3X3GapFill style={{transform: 'translateY(2px)'}} />},
  {label: 'Learn', link: '/learn', icon: <BsBookFill style={{transform: 'translateY(2px)'}} />},
  {label: 'Train', link: '/train', icon: <BsFilterCircleFill style={{transform: 'translateY(2px)'}} />},
  //{label: 'Playground', link: '/playground', icon: <BsConeStriped style={{transform: 'translateY(2px)'}} />}, // Temporarily commented out
  {label: 'Equity', link: '/equity', icon: <BsFillTrophyFill style={{transform: 'translateY(2px)'}} />, requireLogin: true},
  {label: 'Analysis', link: '/history/sessions', icon: <BsClockHistory style={{transform: 'translateY(2px)'}} />},
  {label: 'Profit Tracker', link: '/sessions', icon: <BsBookFill style={{transform: 'translateY(2px)'}} />, requireLogin: true},
  {label: 'Garage', link: '/garage', icon: <BsArchiveFill style={{transform: 'translateY(2px)'}} />, developer: true},
  {label: 'Store', link: '/store', icon: <BsArchiveFill style={{transform: 'translateY(2px)'}} />, developer: true},
  {label: 'Tools', link: '/streamer', icon: <BsTools style={{transform: 'translateY(2px)'}} />, developer: true},
  {label: 'Drift', link: '/drift', icon: <BsCarFrontFill style={{transform: 'translateY(2px)'}} />, developer: true}
];

interface HeaderContextType {
  toggleHeader: () => void;
}

interface MainPageState {
  login: boolean;
  profile: boolean;
  menu: boolean;
  message: string;
  authenticating: boolean;
  navigate: string;
  returnUrl: string;
  isEditing: boolean;
  newDisplayName: string;
  error: string;
  auth0LoginCompleted: boolean;
  isLoggedIn: boolean;
  playerProfile: any;
  displayName: string;
  authMessage: string;
  headerVisible: boolean;
  showLoginDialog: boolean;
  loginCallback?: () => void;
  playerXP: number;
  playerLevel: number;
  xpToNextLevel: number;
  isPremium: boolean;
}
export const HeaderContext = React.createContext<HeaderContextType | undefined>(undefined);


const AUTH0_DOMAIN = 'auth.gymbuddy.io';
const AUTH0_CLIENT_ID = 'TH4y2zz3JdmTBUBXRLLIjaj1E4IakAAa';

function LoginButton() {
  const { loginWithRedirect } = useAuth0();

  const handleLogin = () => {
    console.log("Initiating Discord login via Auth0");
    // sessionStorage.setItem('loginReturnUrl', window.location.pathname);
    loginWithRedirect({
      authorizationParams: {
        redirect_uri: `${window.location.origin}/auth0`,
        connection: 'discord',
        scope: 'openid profile'
      }
    });
  };

  return (
    <button onClick={handleLogin} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <BsDiscord style={{ marginRight: '8px', fontSize: '1.2em' }} />
      Login with Discord
    </button>
  );
}

function GoogleLoginButton() {
  const { loginWithRedirect } = useAuth0();

  const handleGoogleLogin = () => {
    console.log("Initiating Google login via Auth0");
    // sessionStorage.setItem('loginReturnUrl', window.location.pathname);
    loginWithRedirect({
      authorizationParams: {
        redirect_uri: `${window.location.origin}/auth0`,
        connection: 'google-oauth2',
        scope: 'openid profile'
      }
    });
  };

  return (
    <button onClick={handleGoogleLogin} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <BsGoogle style={{ marginRight: '8px', fontSize: '1.2em' }} />
      Login with Google
    </button>
  );
}

function TwitchLoginButton() {
  const { loginWithRedirect } = useAuth0();

  const handleTwitchLogin = () => {
    console.log("Initiating Twitch login via Auth0");
    // sessionStorage.setItem('loginReturnUrl', window.location.pathname);
    loginWithRedirect({
      authorizationParams: {
        redirect_uri: `${window.location.origin}/auth0`,
        connection: 'twitch',
        scope: 'openid profile'
      }
    });
  };

  return (
    <button onClick={handleTwitchLogin} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <BsTwitch style={{ marginRight: '8px', fontSize: '1.2em' }} />
      Login with Twitch
    </button>
  );
}

function TwitterLoginButton() {
  const { loginWithRedirect } = useAuth0();

  const handleTwitterLogin = () => {
    console.log("Initiating Twitter login via Auth0");
    // sessionStorage.setItem('loginReturnUrl', window.location.pathname);
    loginWithRedirect({
      authorizationParams: {
        redirect_uri: `${window.location.origin}/auth0`,
        connection: 'twitter',
        scope: 'openid profile'
      }
    });
  };

  return (
    <button onClick={handleTwitterLogin} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <BsTwitter style={{ marginRight: '8px', fontSize: '1.2em' }} />
      Login with Twitter
    </button>
  );
}

function TikTokLoginButton() {
  const { loginWithRedirect } = useAuth0();

  const handleTikTokLogin = () => {
    console.log("Initiating TikTok login via Auth0");
    // sessionStorage.setItem('loginReturnUrl', window.location.pathname);
    loginWithRedirect({
      authorizationParams: {
        redirect_uri: `${window.location.origin}/auth0`,
        connection: 'tiktok',
        scope: 'user.info.basic',
        response_type: 'code'
      }
    });
  };

  return (
    <button onClick={handleTikTokLogin} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <BsTiktok style={{ marginRight: '8px', fontSize: '1.2em' }} />
      Login with TikTok
    </button>
  );
}

function EmailLoginButton() {
  const { loginWithRedirect } = useAuth0();

  const handleEmailLogin = () => {
    console.log("Initiating Email login via Auth0 Universal Login");
    // sessionStorage.setItem('loginReturnUrl', window.location.pathname);
    loginWithRedirect({
      authorizationParams: {
        redirect_uri: `${window.location.origin}/auth0`,
        // No connection needed for universal login typically
        scope: 'openid profile email' // Add email scope if needed
      }
    });
  };

  return (
    <button onClick={handleEmailLogin} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <BsEnvelope style={{ marginRight: '8px', fontSize: '1.2em' }} />
      Login with Email
    </button>
  );
}

function Auth0Integration() {
  const { isLoading, isAuthenticated, getIdTokenClaims, user, loginWithRedirect } = useAuth0();
  const [loginCompleted, setLoginCompleted] = useState(false);
  const location = useLocation();

  useEffect(() => {
    console.log("Auth0Integration: isLoading:", isLoading, "isAuthenticated:", isAuthenticated);

    async function handleAuth() {
      if (!isLoading) {
        if (isAuthenticated) {
          // Check if PlayFab login is needed (i.e., no valid PlayFab session yet)
          // AND if we haven't already completed the Auth0 part in this component instance
          if (!PlayFab.hasValidSession() && !loginCompleted) {
            window.dispatchEvent(new CustomEvent('set-auth-message', { detail: 'Completing login, please wait...' }));
            console.log("Auth0Integration: Attempting Auth0 token exchange for PlayFab login.");
            try {
              const claims = await getIdTokenClaims();
              if (claims && claims.__raw) {
                console.log("Auth0Integration: Got ID token, calling continueLoginWithAuth0");
                const result = await Account.continueLoginWithAuth0(claims.__raw, user);
                if (result.success) {
                  console.log("Auth0Integration: Auth0 -> PlayFab login successful. Notifying MainPage.");
                  setLoginCompleted(true); // Mark as completed within this instance
                  // Dispatch events on next tick to ensure parent listeners are attached
                  setTimeout(() => {
                    window.dispatchEvent(new Event('auth0-login-completed'));
                    window.dispatchEvent(new Event('playfab-session-check'));
                    window.dispatchEvent(new CustomEvent('set-auth-message', { detail: '' }));
                  }, 0);
                } else {
                  console.error("Auth0Integration: continueLoginWithAuth0 failed", result.error);
                  window.dispatchEvent(new CustomEvent('set-auth-message', { detail: 'Login failed.' }));
                }
              } else {
                 console.error("Auth0Integration: Could not get ID token claims.");
                 window.dispatchEvent(new CustomEvent('set-auth-message', { detail: 'Error fetching credentials.' }));
              }
            } catch (error) {
              console.error("Auth0Integration: Error during token exchange", error);
              window.dispatchEvent(new CustomEvent('set-auth-message', { detail: 'Error during login.' }));
            }
          } else if (PlayFab.hasValidSession()) {
              // If PlayFab session is already valid, Auth0Integration doesn't need to do anything more here.
              // MainPage should handle the logged-in state based on PlayFab.hasValidSession() or its own state.
              console.log("Auth0Integration: Auth0 authenticated and PlayFab session already valid.");
          } else if (!PlayFab.hasValidSession() && loginCompleted) {
              // This state means Auth0->PlayFab succeeded in this instance, but maybe PlayFab session expired?
              console.warn("Auth0Integration: Auth0 authenticated, login process completed in this instance, but PlayFab session is invalid.");
          }
        } else if (!isAuthenticated && PlayFab.hasValidSession()) {
          // This handles re-authentication if Auth0 session expires but PlayFab is still valid
          // Avoid redirect loops while on the callback path
          if (window.location.pathname !== '/auth0') {
            window.dispatchEvent(new CustomEvent('set-auth-message', { detail: 'Re-authenticating, please wait...' }));
            await loginWithRedirect({
              appState: { returnTo: window.location.pathname },
              authorizationParams: { redirect_uri: `${window.location.origin}/auth0` }
            });
          }
        }
      }
    }

    handleAuth();
  }, [isLoading, isAuthenticated, getIdTokenClaims, user, loginCompleted, loginWithRedirect]);

  useEffect(() => {
    if (location.pathname === '/auth0') {
      window.dispatchEvent(new CustomEvent('set-auth-message', { detail: 'Processing login, please wait...' }));
    }
  }, [location]);

  return null;
}

function LogoutButton({ onLogout }: { onLogout: () => void }) {
  const { logout } = useAuth0();
  
  const handleLogout = async () => {
    // Clear Auth0 session
    await logout({ logoutParams: { returnTo: window.location.origin + '/logout' } });
    // Clear account state and local storage
    Account.logout();
    // Disconnect from network
    Network.disconnect();
    // Call the parent's onLogout function
    onLogout();
  };

  return <button onClick={handleLogout}>Logout</button>;
}

// Define the custom event type
interface SetAuthMessageEvent extends CustomEvent {
  detail: string;
}

class MainPage extends React.Component<{}, MainPageState> {
  static contextType = HeaderContext;
  constructor(props: {}) {
    super(props);
    this.state = {
      login: false,
      profile: false,
      menu: false,
      message: '',
      authenticating: true,
      navigate: '',
      returnUrl: '/',
      isEditing: false,
      newDisplayName: Account.getUserName(),
      error: '',
      auth0LoginCompleted: false,
      isLoggedIn: false,
      playerProfile: null,
      displayName: '',
      authMessage: '',
      headerVisible: true,
      showLoginDialog: false,
      loginCallback: undefined,
      playerXP: 0,
      playerLevel: 0,
      xpToNextLevel: 100,
      isPremium: false,
    }
  }

  componentDidMount(): void {
    document.title = 'GymBuddy';
    
    window.addEventListener('auth0-login-completed', this.handleAuth0LoginCompleted);
    window.addEventListener('playfab-session-check', this.checkPlayFabSession);
    window.addEventListener('set-auth-message', this.handleSetAuthMessage as EventListener);
    this.initializeUser();

    // Add event listener for login popup request
    window.addEventListener('showLogin', ((event: CustomEvent) => {
      // Don't show login dialog if we're already in the auth process
      if (this.state.authenticating) {
        return;
      }

      // Only set returnUrl if it hasn't been set already
      if (!sessionStorage.getItem('loginReturnUrl')) {
        sessionStorage.setItem('loginReturnUrl', window.location.pathname + window.location.search);
      }
      
      this.setState({ 
        login: true,
        loginCallback: event.detail?.callback 
      });
    }) as EventListener);
  }

  componentWillUnmount() {
    window.removeEventListener('auth0-login-completed', this.handleAuth0LoginCompleted);
    window.removeEventListener('playfab-session-check', this.checkPlayFabSession);
    window.removeEventListener('set-auth-message', this.handleSetAuthMessage as EventListener);
  }

  checkPlayFabSession = () => {
    // If we have a valid PlayFab session but the MainPage state doesn't reflect it yet,
    // update the state by calling the handler directly.
    if (PlayFab.hasValidSession() && !this.state.isLoggedIn) {
      console.log("MainPage: Valid PlayFab session found, but state not updated. Syncing state.");
      this.handleAuth0LoginCompleted(); // Call the handler to update state and potentially navigate
      // window.dispatchEvent(new Event('auth0-login-completed')); // Don't fire the event again
    }
  }

  initializeUser = async () => {
    this.setState({ authenticating: true, message: 'Initializing...' });

    try {
      if (Account.isLoggedIn() || PlayFab.hasValidSession()) {
        this.setState({ message: 'Loading profile...' });
        await this.loadPlayerProfile();
        // Clear auth message here as well
        this.setState({ isLoggedIn: true, authMessage: '' }); 
      } else if (Account.hasAutoLogin()) {
        this.setState({ message: 'Logging in, please wait...' });

      }
    } catch (error) {
      console.error('Initialization failed:', error);
    } finally {
      this.setState({ authenticating: false, message: '' });
    }

    // Add this at the end of the method
    setTimeout(() => {
      window.dispatchEvent(new Event('playfab-session-check'));
    }, 1000); // Check after a short delay
  };

  calculateLevelAndXP(totalXP: number) {
    const xpPerLevel = 100; // Fixed XP per level
    const level = Math.floor(totalXP / xpPerLevel);
    const currentLevelXP = totalXP % xpPerLevel;
    
    return {
      level,
      currentXP: currentLevelXP,
      xpToNextLevel: xpPerLevel
    };
  }

  loadPlayerProfile = async () => {
    if (PlayFab.hasValidSession()) {
      try {
        console.log("MainPage: Calling PlayFab.getPlayerProfile()");
        const profile = await PlayFab.getPlayerProfile();
        console.log("MainPage: Received profile:", profile);
        
        // Ensure profile is not null/undefined before proceeding
        if (!profile) {
          console.error("MainPage: Failed to get player profile from PlayFab.");
          return; // Exit if profile is invalid
        }

        let isPremium = false; // Default to false
        try {
          const currentPath = window.location.pathname;
          const suppressStatusCheck = currentPath.startsWith('/hand-review');
          if (!suppressStatusCheck) {
            console.log("MainPage: Calling getPlayerAnalysisStatus CloudScript");
            const analysisStatusResult = await PlayFab.executeCloudScript({
              FunctionName: 'getPlayerAnalysisStatus',
              FunctionParameter: {}
            });

            if (analysisStatusResult.success && analysisStatusResult.data?.FunctionResult?.FunctionResult?.success) {
              isPremium = analysisStatusResult.data.FunctionResult.FunctionResult.isPremium;
            } else {
              const cloudScriptError = analysisStatusResult.data?.FunctionResult?.Error;
              const functionResultError = analysisStatusResult.data?.FunctionResult?.FunctionResult?.error;
              console.warn("MainPage: getPlayerAnalysisStatus reported:", cloudScriptError || functionResultError || "Unknown error");
            }
          } else {
            // Avoid noisy status checks while reviewing a hand
            // console.debug('MainPage: Skipping analysis status check on hand review route');
          }
        } catch (cloudScriptError) {
          console.warn("MainPage: Error calling getPlayerAnalysisStatus CloudScript:", cloudScriptError);
          // Keep isPremium as default false
        }

        try {
          console.log("MainPage: Calling PlayFab.getUserReadOnlyData(['XP'])");
          const playerData = await PlayFab.getUserReadOnlyData(['XP']);
          console.log('Raw player data:', playerData);
          
          let xp = 0;
          if (playerData.success && playerData.data?.XP?.Value) {
            try {
              const xpData = JSON.parse(playerData.data.XP.Value);
              xp = xpData.value || 0; // Get XP from the value field of the JSON object
              console.log('Parsed XP data:', xpData);
              console.log('Parsed XP value:', xp);
            } catch (e) {
              console.error('Error parsing XP JSON:', e);
              // Fallback for old format
              xp = parseInt(playerData.data.XP.Value) || 0;
            }
          }

          // Update level calculation: Level 1 starts at 0 XP
          const level = Math.floor(xp / 100) + 1;
          const currentLevelXP = xp % 100;

          // Log the values being used to set the state
          const fetchedDisplayName = profile.DisplayName;
          const fallbackUsername = Account.getUserName();
          console.log(`MainPage: Setting displayName. Fetched: '${fetchedDisplayName}', Fallback: '${fallbackUsername}'`);

          this.setState({ 
            playerProfile: profile,
            displayName: fetchedDisplayName || fallbackUsername,
            newDisplayName: fetchedDisplayName || fallbackUsername,
            playerXP: currentLevelXP, // Store XP progress towards next level
            playerLevel: level, // Store current level
            xpToNextLevel: 100,
            isPremium: isPremium // Set the premium status
          }, () => {
            // Log the state *after* it has been set
            console.log("MainPage: displayName state after setState:", this.state.displayName);
            console.log("MainPage: isPremium state after setState:", this.state.isPremium);
          });

        } catch (error) {
          console.error('Failed to load XP:', error);
        }
      } catch (error) {
        console.error('Failed to load profile:', error);
      }
    }
  }

  handleAuth0LoginCompleted = () => {
    console.log("MainPage: Auth0 login completed");
    this.setState({
      auth0LoginCompleted: true,
      isLoggedIn: true,
      login: false, // Close the login dialog if it was open
      authenticating: false  // Make sure to reset authenticating
    }, async () => { // Callback after state is set
      await this.loadPlayerProfile(); // Load profile first

      if (this.state.loginCallback) {
        this.state.loginCallback();
        this.setState({ loginCallback: undefined });
      }

      // Check for a return URL stored in sessionStorage
      const returnUrl = sessionStorage.getItem('loginReturnUrl');
      let navigateTo = '/buddy'; // Default navigation target

      if (returnUrl) {
        console.log("Login successful, returning to saved URL:", returnUrl);
        navigateTo = returnUrl;
        sessionStorage.removeItem('loginReturnUrl'); // Clear the stored URL
      } else {
        console.log("Login successful, navigating to default /buddy");
      }

      this.setState({ navigate: navigateTo });
      // Reset navigate state shortly after to allow subsequent navigation
      setTimeout(() => this.setState({ navigate: '' }), 0);
    });
  }

  onLogin() {
    // Store current path before showing login dialog - REMOVED as we always go to /buddy
    // sessionStorage.setItem('loginReturnUrl', window.location.pathname + window.location.search);
    
    this.setState({
      login: true,
      // Remove returnUrl from state since we're using sessionStorage
      // returnUrl: window.location.pathname + window.location.search
    });
  }

  onLogout = () => {
    Account.logout();
    this.setState({
      message: '',
      auth0LoginCompleted: false,
      profile: false,
      isLoggedIn: false,
      playerProfile: null,
      displayName: '',
      // Reset other relevant state properties
    });
    // Optionally, redirect to home page
    this.setState({navigate: '/'});
  }

  onProfile() {
    this.setState({ profile: true });
    this.loadPlayerProfile();
    console.log("MainPage: Profile icon clicked, showing dialog and loading profile data in background...");
  }

  onMenu() {
    this.setState({menu: true});
  }

  renderHeaderMenu(name:string, path:string) {
    return (
      <NavLink to={path} className="main-page-header-link">
        {name}
      </NavLink>
    )    
  }

  renderHeader() {
    let links = [];
    for(let i = 0; i < menu.length; i++) {
      // Skip developer menu items since isDeveloperLoggedIn will return false
      if(menu[i].developer) 
        continue;
      
      const isLoggedIn = Account.isLoggedIn() || PlayFab.hasValidSession();
      const loggedInUserId = isLoggedIn ? PlayFab.getPlayerId() : null;

      // Skip items requiring login if not logged in
      if(menu[i].requireLogin && !isLoggedIn)
        continue;

      // Construct the correct path for history based on login status
      let path = menu[i].link;
      if (menu[i].label === 'Analysis') {
          if (loggedInUserId) {
              path = `/history/user/${loggedInUserId}/sessions`; // Use logged-in user's ID
          } else {
              // Optional: Decide what to do if not logged in. Hide the link? Link to login?
              // For now, let's hide it by skipping the push.
              continue; 
          }
      }

      links.push(
        <NavLink key={i} to={path} className="main-page-header-link">
          {menu[i].label}
        </NavLink>
      )
    }

    const xpBarContent = this.state.playerProfile && (
      <div className="xp-bar-container">
        <div className="xp-bar">
          <div 
            className="xp-bar-fill" 
            style={{
              width: `${(this.state.playerXP / 100) * 100}%`
            }}
          />
        </div>
        <div className="xp-text">
          Level {this.state.playerLevel} - {this.state.playerXP}/100 XP
        </div>
      </div>
    );

    // Check screen width - basic check, might need refinement
    const isMobile = window.innerWidth <= 800; 

    return (
      <div className="main-page-header">
        <div className="main-page-header-grid">
          <div className="main-page-header-menu" onClick={()=>this.onMenu()}>
            <BsFilterCircleFill />
          </div>

          <div className="main-page-header-logo">
            <img 
              src="/images/PokerBuddy.png" 
              alt="GymBuddy" 
              style={{height: '24px', marginRight: '8px', verticalAlign: 'middle'}} 
            />
            <span className="pokerbuddy-title">GymBuddy</span>
          </div>

          <div className="main-page-header-links">
            {links}
          </div>

          {/* Only render XP bar in header on desktop */}
          {!isMobile && (
            <div className="main-page-header-xp">
              {xpBarContent}
            </div>
          )}

          {this.state.authenticating &&
            <div className="main-page-header-authenticating-button">
              <BsBroadcast/>
            </div>
          }
          {!this.state.authenticating && this.state.playerProfile &&
            <div className="main-page-header-portrait" onClick={()=>this.onProfile()}>
              <BsPersonCircle style={{width: '100%', height: '100%'}} />
            </div>
          }
          {!this.state.authenticating && !this.state.playerProfile &&
            <div className="main-page-header-login-button" onClick={()=>this.onLogin()}>
              <BsPersonCircle />
            </div>
          }
          {!this.state.authenticating && !this.state.playerProfile &&
            <div className="main-page-header-login" onClick={()=>this.onLogin()}>
              Log In
            </div>
          }
        </div>
      </div>
    )
  }

  renderLoginDialog() {
    return (
      <div className="dialog-cover">
        <div className="dialog-panel" style={{width: '250px'}}>
          <div>
            <img style={{height: '36px'}} src="/images/PokerBuddy.png" alt="GymBuddy"/>
          </div>
          <div className="flex-column" style={{marginTop: '10px'}}>
            {/* <LoginButton /> */}
            <GoogleLoginButton />
            {/* <TwitchLoginButton /> */}
            {/* <TwitterLoginButton /> */}
            {/* <TikTokLoginButton /> */}
            <EmailLoginButton />
            {/* <button disabled={true}>
              <BsFacebook style={{transform: 'translateY(3px)'}} />&nbsp;&nbsp;Login with Facebook
            </button> */}
            {/* <button disabled={true}>
              <BsEnvelope style={{transform: 'translateY(4px)'}} />&nbsp;&nbsp;Login with Email
            </button> */}
            <button 
              style={{background: '#213e70'}} 
              onClick={() => {
                this.setState({ login: false });
                // If closing the prompted login, redirect to home
                if (window.location.pathname !== '/') {
                  this.setState({ navigate: '/' });
                  // Reset navigate state shortly after to allow subsequent navigation
                  setTimeout(() => this.setState({ navigate: '' }), 0); 
                }
              }}
            >
              Close
            </button>
          </div>
        </div>
      </div>
    )
  }

  renderProfileDialog() {
    if (!this.state.playerProfile) return null;

    // Define xpBarContent here as well or pass from render
    const xpBarContent = this.state.playerProfile && (
      <div className="xp-bar-container">
        <div className="xp-bar">
          <div 
            className="xp-bar-fill" 
            style={{
              width: `${(this.state.playerXP / 100) * 100}%`
            }}
          />
        </div>
        <div className="xp-text">
          Level {this.state.playerLevel} - {this.state.playerXP}/100 XP
        </div>
      </div>
    );

    // Keep the premiumIcon definition
    const premiumIcon = this.state.isPremium && (
      <BsCheckCircleFill style={{ color: 'gold', marginLeft: '5px', verticalAlign: 'middle' }} />
    );

    // Define the premium status text line
    const premiumStatusLine = this.state.isPremium && (
      <div style={{ marginTop: '5px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <span style={{ color: 'gold', fontWeight: 'bold' }}>Premium Member</span>
        {premiumIcon}
      </div>
    );

    return (
      <div className="dialog-cover">
        <div className="dialog-panel" style={{width: '250px'}}>
          <div className="flex-column">
            <BsPersonCircle 
              style={{width: '120px', height: '120px', margin: 'auto'}} 
            />
            {/* Render XP Bar in Profile Dialog */} 
            {xpBarContent}

            {this.state.isEditing ? (
              <div>
                <input
                  type="text"
                  value={this.state.newDisplayName}
                  onChange={(e) => this.setState({ newDisplayName: e.target.value })}
                  maxLength={25}
                />
                {/* Remove premiumIcon from here */}
                <button onClick={this.handleSave}>Save</button>
                <button onClick={this.handleCancel}>Cancel</button>
                {this.state.error && <p className="error">{this.state.error}</p>}
              </div>
            ) : (
              <div>
                {/* Display name ONLY */}
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <span>{this.state.displayName}</span>
                  {/* Remove premiumIcon from here */}
                </div>
                {/* Render Premium Status Line if applicable */}
                {premiumStatusLine}
                <button onClick={this.handleEdit}>Edit Display Name</button>
              </div>
            )}
            <div className="flex-column" style={{marginTop: '10px'}}>
              {/* Manage Subscription Link */}
              {this.state.isPremium && (
                <a 
                  href="https://billing.stripe.com/p/login/cN26rH1nY1I1e4w8ww" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  style={{textDecoration: 'none'}}
                >
                  <button style={{width: '100%'}}>Manage Subscription</button>
                </a>
              )}
              {/* <button>Account</button> */}
              {/* <button>Settings</button> */}
              <LogoutButton onLogout={this.onLogout} />
              <button style={{background: '#213e70'}} onClick={() => this.setState({profile: false})}>Close</button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  handleEdit = () => {
    this.setState({ isEditing: true, newDisplayName: this.state.displayName, error: '' });
  }

  handleCancel = () => {
    this.setState({ isEditing: false, newDisplayName: this.state.displayName, error: '' });
  }

  handleSave = async () => {
    if (this.state.newDisplayName.trim() === '') {
      this.setState({ error: 'Display name cannot be empty' });
      return;
    }

    this.setState({ message: 'Updating display name...' });

    try {
      const success = await Account.updateDisplayName(this.state.newDisplayName.trim());
      if (success) {
        this.setState({ isEditing: false, error: '', message: 'Refreshing profile...' });
        
        // Perform another GetPlayerProfile call
        await this.loadPlayerProfile();
        
        this.setState({ message: '' });
      } else {
        this.setState({ error: 'Failed to update display name. Please try again.', message: '' });
      }
    } catch (error) {
      console.error('Error updating display name:', error);
      this.setState({ error: 'An error occurred while updating display name.', message: '' });
    }
  }

  renderMessageDialog() {
    return (
      <div className="dialog-cover">
        <div className="dialog-panel" style={{maxWidth: '250px', padding: '20px'}}>
          {this.state.message}
        </div>
      </div>
    )
  }

  renderMenuDialog() {
    let buttons = [];
    const isLoggedIn = Account.isLoggedIn() || PlayFab.hasValidSession();
    const loggedInUserId = isLoggedIn ? PlayFab.getPlayerId() : null;

    for (let i = 0; i < menu.length; i++) {
      if (menu[i].developer && !Account.isDeveloperLoggedIn())
        continue;

      if (menu[i].requireLogin && !isLoggedIn)
        continue;

      let path = menu[i].link;
      if (menu[i].label === 'Analysis') {
        if (loggedInUserId) {
          path = `/history/user/${loggedInUserId}/sessions`;
        } else {
          continue;
        }
      }

      buttons.push(
        <NavLink
          key={i}
          to={path}
          onClick={() => this.setState({ menu: false })}
          className="menu-link"
        >
          <span className="menu-link-icon">{menu[i].icon}</span>
          <span className="menu-link-label">{menu[i].label}</span>
        </NavLink>
      );
    }

    return (
      <div className="dialog-cover">
        <div className="dialog-panel menu-dialog-panel">
          <div>
            <img style={{height: '36px'}} src="/images/PokerBuddy.png" alt="GymBuddy"/>
          </div>
          <div className="flex-column menu-list" style={{marginTop: '10px'}}>
            {buttons}
            <button className="menu-close-button" onClick={()=>this.setState({menu: false})}>Close</button>
          </div>
        </div>
      </div>
    )
  }

  handleSetAuthMessage = (event: SetAuthMessageEvent) => {
    this.setState({ authMessage: event.detail });
  }

  renderAuthMessageDialog() {
    if (!this.state.authMessage) return null;
    return (
      <div className="dialog-cover">
        <div className="dialog-panel" style={{maxWidth: '250px', padding: '20px'}}>
          {this.state.authMessage}
        </div>
      </div>
    )
  }

  toggleHeader = () => {
    this.setState(prevState => ({ headerVisible: !prevState.headerVisible }));
  }

  // When login completes successfully
  onLoginSuccess = () => {
    if (this.state.loginCallback) {
      this.state.loginCallback();
    }
    this.setState({ 
      login: false,
      loginCallback: undefined
    });
  }

  componentDidUpdate(prevProps: {}, prevState: MainPageState) {
    const currentPath = window.location.pathname;
    const isHomePage = currentPath === '/';
    const isAuthCallback = currentPath.startsWith('/auth0');
    const needsLogin = !this.state.isLoggedIn;
    const isAuthenticating = this.state.authenticating;
    const loginDialogAlreadyOpen = this.state.login;

    // Check if we should prompt for login
    if (!isAuthenticating && needsLogin && !isHomePage && !isAuthCallback && !loginDialogAlreadyOpen) {
      // Ensure we don't get into a loop if state update is slow
      const previouslyNeededLogin = !prevState.isLoggedIn;
      const previouslyAuthenticating = prevState.authenticating;
      const previousLoginDialogOpen = prevState.login;
      
      if (!( !previouslyAuthenticating && previouslyNeededLogin && !isHomePage && !previousLoginDialogOpen)) {
          console.log(`Triggering login prompt for path: ${currentPath}`);
          if (!isAuthCallback) {
            sessionStorage.setItem('loginReturnUrl', currentPath + window.location.search);
          }
          this.setState({ login: true });
      }
    }
  }

  render() {
    if(this.state.navigate != '')
      return <Navigate to={this.state.navigate} />
      
    return (
      <Auth0Provider
        domain={AUTH0_DOMAIN}
        clientId={AUTH0_CLIENT_ID}
        authorizationParams={{
          redirect_uri: `${window.location.origin}/auth0`,
          scope: 'openid profile'
        }}
      >
        <Auth0Integration />
        <HeaderContext.Provider value={{ toggleHeader: this.toggleHeader }}>
        <div>
          {this.state.headerVisible && this.renderHeader()}
          {/* <button 
            onClick={this.toggleHeader}
            style={{
              position: 'fixed',
              top: '10px',
              right: '10px',
              zIndex: 1000,
              padding: '5px 10px',
              background: '#213e70',
              color: 'white',
              border: 'none',
              borderRadius: '5px',
              cursor: 'pointer'
            }}
          >
            {this.state.headerVisible ? 'Hide Header' : 'Show Header'}
          </button> */}
          {!this.state.authenticating &&
            <Outlet />
          }
          {this.state.login && this.renderLoginDialog()}
          {this.state.profile && this.renderProfileDialog()}
          {this.state.menu && this.renderMenuDialog()}
          {this.state.message != '' && this.renderMessageDialog()}
          {this.renderAuthMessageDialog()}
          {this.state.showLoginDialog && (
            <div className="dialog-cover">
              <div className="dialog-panel" style={{width: '250px'}}>
                <div>Please login to play</div>
                <div>
                  <button 
                    style={{marginTop: '25px'}} 
                    onClick={() => {
                      // Trigger MainPage login popup
                      window.dispatchEvent(new CustomEvent('showLogin', {
                        detail: { callback: this.onLoginSuccess }
                      }));
                    }}
                  >
                    Login
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
        </HeaderContext.Provider>
      </Auth0Provider>
    );
  }
}

export default MainPage;